<template>
  <div class="col-lg-6 mb-3">
    <div class=" card shadow-sm">
      <CardHeader :productSale="firstProduct"></CardHeader>
      <ul class="list-group list-group-flush">
        <li
          v-for="(productSale, i2) in saleGroup"
          :key="i2"
          class="list-group-item"
        >
          <span class="bg-primary text-white p-1 rounded mr-1"
            >{{ productSale.quantity }}
          </span>
          <span v-bg-color="`#${productSale.color}`" class="rounded"
            >{{ productSale.product_name }}
          </span>
        </li>
      </ul>
      <div class="card-body pb-0">
        <div
          class="alert alert-info mb-0"
          v-show="
            firstProduct.observation && firstProduct.observation.length > 0
          "
        >
          <i class="fas fa-comment"></i>
          {{ firstProduct.observation }}
        </div>
      </div>
      <div class="card-body text-center">
        <app-button-submit
          v-show="firstProduct.maked == 0"
          class="btn btn-secondary text-nowrap"
          @click="makeGroup"
        >
          <!-- @click="$emit('make', productSale.product_sale_id)" -->
          <i class="fa fa-check"></i> REALIZADO
        </app-button-submit>

        <app-button-submit
          v-show="firstProduct.maked == 1"
          class="btn btn-danger"
          @click="undoGroup"
        >
          <!-- @click="$emit('undo', productSale.product_sale_id)" -->
          <i class="fa fa-times"></i> DESHACER
        </app-button-submit>
      </div>
    </div>
  </div>
</template>
<script>
import { DinnerService } from "../DinnerService.js";
import { ticketLinkFactory } from "./ticketLinkFactory.js";
import CardHeader from "./CardHeader.vue";

const setBgColor = function(el, { value }) {
  el.style.backgroundColor = `${value}` || "green";
};

export default {
  components: {
    // CardProductSale
    CardHeader
  },

  directives: {
    bgColor: {
      bind: setBgColor,
      update: setBgColor
    }
  },

  // filters

  props: {
    saleGroup: {
      default: () => []
    }
  },

  data: () => ({
    //
  }),

  computed: {
    firstProduct() {
      return this.saleGroup[0] ? this.saleGroup[0] : {};
    },
    ticketLink() {
      return ticketLinkFactory(this.saleGroup[0].sale_id);
    },
    hideId() {
      if (!this.saleGroup[0].sale_id) return "";
      var idInString = this.saleGroup[0].sale_id.toString();
      return idInString.slice(0, idInString.length - 3);
    },
    customId() {
      if (!this.saleGroup[0].sale_id) return "";
      var idInString = this.saleGroup[0].sale_id.toString();
      return idInString.slice(idInString.length - 3, idInString.length);
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    undoGroup() {
      DinnerService.savePreparedProducts(
        this.saleGroup.map((x) => x.product_sale_id),
        false
      ).then(() => {
        this.$emit("maked");
      });
    },
    makeGroup() {
      DinnerService.savePreparedProducts(
        this.saleGroup.map((x) => x.product_sale_id)
      ).then(() => {
        this.$emit("maked");
      });
    }
  }
};
</script>

<style scoped>
.custom_hover {
  color: white;
  background-color: black;
}

.d-info {
  display: flex;
  justify-content: flex-end;
}
</style>
